<div class="flex h-screen">
  <!-- Sidebar -->
  <div class="transition-all duration-300 overflow-hidden {{sidebarOpen ? 'w-64' : 'w-20'}} bg-green-600 shadow-lg flex flex-col absolute z-100 h-screen">
    <!-- Logo/Brand -->
    <div class="px-6 py-5 border-b border-green-500">
      <h1 *ngIf="sidebarOpen" class="font-cormorant text-xl font-semibold text-black whitespace-nowrap duration-200" (click)="toggleSidebar()">Admin Panel</h1>
      <h1 *ngIf="!sidebarOpen" class="font-cormorant text-xl font-semibold text-black whitespace-nowrap duration-200" (click)="toggleSidebar()">AP</h1>
    </div>

    <!-- Navigation -->
    <nav class="p-4 flex-grow">
      <ul class="space-y-1">
        @for (item of sidebarOptions; track $index) {
          <li>
            <a routerLink="{{ item.link }}" class="flex items-center p-3 rounded-md transition-all duration-200 {{item.isActive ? 'bg-green-200 text-black font-medium' : 'text-black hover:bg-green-500 font-normal'}}">
              <span-lucide [img]=item.icon class="text-black min-w-6"></span-lucide>
              <span class="ml-3 whitespace-nowrap overflow-hidden {{!sidebarOpen ? 'hidden' : ''}}">
                {{ item.title }}
              </span>
            </a>
          </li>
        }
      </ul>
    </nav>

    <!-- User Section -->
    <div class="w-full p-4 border-t border-green-500 mt-auto">
      <div class="flex items-center">
        <div class="h-10 w-10 rounded-full bg-green-200 flex items-center justify-center text-black font-medium shrink-0">
          A
        </div>
        <div class="ml-3 overflow-hidden {{!sidebarOpen ? 'hidden' : ''}}">
          <p class="text-sm font-medium text-black truncate">{{user?.userData?.name || 'User Name'}}</p>
          <p class="text-xs text-green-100 truncate">{{ user?.userData?.email || 'admin@example.com' }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div class="flex-1 bg-white ml-20 h-screen overflow-scroll">
    <router-outlet></router-outlet>
  </div>
</div>
